import { LicensesType } from 'models/IUserData'
import { WidgetConfig, WidgetSize, WidgetType } from '../types'

export const DEFAULT_WIDGETS: WidgetConfig[] = [
	{
		id: WidgetType.IDENTIFICATE,
		type: WidgetType.IDENTIFICATE,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.HERD_STRUCTURE,
		type: WidgetType.HERD_STRUCTURE,
		size: WidgetSize.MEDIUM,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.ACTUAL_YIELD,
		type: WidgetType.ACTUAL_YIELD,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.REJECTED_MILK_YIELD,
		type: WidgetType.REJECTED_MILK_YIELD,
		size: WidgetSize.SMALL,
		license: LicensesType.IDENTIFICATION,
	},
	{
		id: WidgetType.MILKING_DEVIATIONS,
		type: WidgetType.MILKING_DEVIATIONS,
		size: WidgetSize.SMALL,
		license: LicensesType.MILKING_PROCESS,
	},
	{
		id: WidgetType.DEVIATIONS_FEED_TABLE,
		type: WidgetType.DEVIATIONS_FEED_TABLE,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.PSV_HERD_STRUCTURE,
		type: WidgetType.PSV_HERD_STRUCTURE,
		size: WidgetSize.MEDIUM,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.FEED_AVAILABILITY,
		type: WidgetType.FEED_AVAILABILITY,
		size: WidgetSize.FULL,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.LAMENESS_LINE_CHART,
		type: WidgetType.LAMENESS_LINE_CHART,
		size: WidgetSize.LARGE,
		license: LicensesType.LAMENESS,
	},
	{
		id: WidgetType.FATNESS_DONUT_CHART,
		type: WidgetType.FATNESS_DONUT_CHART,
		size: WidgetSize.LARGE,
		license: LicensesType.FATNESS,
	},
	{
		id: WidgetType.DISPOSE_RECOMMENDED,
		type: WidgetType.DISPOSE_RECOMMENDED,
		size: WidgetSize.SMALL,
		license: LicensesType.LAMENESS,
	},
]
